import classNames from "classnames";
import PropTypes from "prop-types";

export const Quotation = ({ children, classes }) => {
  return <p className={classNames(classes, "quotation")}>{children}</p>;
};

Quotation.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.string,
};
